import { useEffect, useState } from "react";
import { tagular } from "@cohesion/tagular";

import { LinkFill } from "@icons/link";

const texts = {
  0: "Copy Link",
  1: "Link Copied",
};

export function CopyButton() {
  const [heading, setHeading] = useState(texts[0]);

  const handleCopy = () => {
    const url = window.location.href;

    if (navigator.clipboard) {
      // Modern approach with Clipboard API
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setHeading("Link Copied");
        })
        .catch(err => {
          setHeading("Failed to copy");
          // eslint-disable-next-line no-console
          console.error("Failed to copy", err);
        });
    } else {
      // Fallback using document.execCommand()
      // Create a temporary text area to hold the URL
      const textArea = document.createElement("textarea");
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        // Attempt to copy the text
        const successful = document.execCommand("copy");
        if (successful) {
          setHeading("Link Copied");
        }
      } catch (err) {
        setHeading("Failed to copy");
        // eslint-disable-next-line no-console
        console.error("Failed to copy", err);
      }

      // Cleanup: remove the temporary text area
      document.body.removeChild(textArea);
    }

    tagular("click", {
      actionOutcome: "SHARE",
      outboundUrl: "null",
      webElement: {
        location: "BITHOME",
        elementType: "BUTTON",
        position: "DESTINATION",
        text: "COPYTOCLIPBOARD",
        name: url,
      },
    });
  };

  useEffect(() => {
    if (heading === texts[1]) {
      setTimeout(() => {
        setHeading(texts[0]);
      }, 3000);
    }
  }, [heading]);

  return (
    <button
      type="button"
      className="flex items-center justify-between w-full"
      onClick={() => handleCopy()}
    >
      <div className="flex items-center justify-start">
        <div>
          <LinkFill />
        </div>
        <div className="ml-4 text-left">
          <h4 className="text-lg leading-tight capitalize">{heading}</h4>
        </div>
      </div>
    </button>
  );
}
